import { FC } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { PanelInfoAppTheme } from '../../../survey-tool/declarations/ah-api';
import { useAppSelector } from '../../../store';

interface LoginRightComponentProps {
  backgroundImage?: string;
}

interface stylingOptions extends PanelInfoAppTheme {
  backgroundImage: string | undefined;
}

const useStyles = makeStyles<any, stylingOptions>({
  right: {
    backgroundImage: ({ backgroundImage }) => `url(${backgroundImage})`,
    display: 'flex',
    height: '100%',
    width: '100%;',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
  },
});

export const LoginRightComponent: FC<LoginRightComponentProps> = ({ backgroundImage }) => {
  const panelInfo = useAppSelector((state) => state.panelInfo);
  const classes = useStyles({ ...panelInfo?.app_theme, backgroundImage });

  return <div className={classes.right} />;
};
